(function() {
  const frontCard = document.querySelectorAll(".media-block__front");
  const reverseFlip = document.querySelectorAll(".reverse-flip");

  frontCard.forEach(card => {
    card.addEventListener("click", e => {
      e.preventDefault();
      const mediaBlock = card.closest(".media-block");
      const backSide = mediaBlock.querySelector(".media-block__back");

      backSide.querySelectorAll(".btn, .reverse-flip").forEach(link => {
        link.removeAttribute("tabindex");
      });

      card.setAttribute("aria-hidden", "true");
      mediaBlock
        .querySelector(".media-block__back")
        .setAttribute("aria-hidden", "false");
      mediaBlock.classList.add("flipped");
      card.querySelector(".card-flip").setAttribute("tabindex", "-1");
      backSide.querySelector(".btn").setAttribute("tabindex", "0");
    });
  });

  reverseFlip.forEach(flip => {
    flip.addEventListener("click", e => {
      e.preventDefault();
      const mediaBlock = flip.closest(".media-block");
      const backSide = flip.closest(".media-block__back");
      const frontSide = mediaBlock.querySelector(".media-block__front");
      backSide.setAttribute("aria-hidden", "true");
      frontSide.setAttribute("aria-hidden", "false");

      backSide.querySelectorAll(".btn, .reverse-flip").forEach(link => {
        link.setAttribute("tabindex", "-1");
      });

      frontSide.querySelector(".card-flip").setAttribute("tabindex", "0");
      mediaBlock.classList.remove("flipped");
    });
  });
})();
